import "./App.scss";
import {  Home } from "./container";
import { Navbar } from "./components";
import NoteState from "./context/notes/NoteState";

function App() {
  return (
    <>
      <NoteState>
        <Navbar />
          <Home />
      </NoteState>
    </>
  );
}

export default App;
